module.exports = __webpack_public_path__ + "static/media/disconnectIcon.aef53985.svg";